<template>
  <v-row no-gutters align="start" justify="end">
    <v-col cols="6">
      <h5 class="secondary-font">{{ text }}</h5>
      <v-input v-model="model.value" :rules="[v => v !== null || 'Resposta obrigatória']"></v-input>
    </v-col>
    <v-col cols="6" class="d-flex justify-end">
      <v-btn-toggle
        v-model="model.value"
        class="bg-default"
        style="position: relative"
        :mandatory="model.value !== null"
      >
        <v-row no-gutters>
          <v-btn
            :value="1"
            active-class="error white--text"
            class="mr-3 text-capitalize secondary-font white"
            outlined
            small
            >Ruim</v-btn
          >
          <v-btn
            :value="2"
            active-class="warning white--text"
            class="mr-3 text-capitalize secondary-font white"
            outlined
            small
            >Bom</v-btn
          >
          <v-btn
            :value="3"
            active-class="success white--text"
            class="text-capitalize secondary-font white"
            outlined
            small
            >Ótimo</v-btn
          >
        </v-row>
      </v-btn-toggle>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style></style>
